import { render } from "./FlashMessages.vue?vue&type=template&id=e85319b0"
import script from "./FlashMessages.vue?vue&type=script&lang=js"
export * from "./FlashMessages.vue?vue&type=script&lang=js"

import exportComponent from "/Users/niq/Documents/Project Apps/TMI/Helpdesk App/apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__